module.exports = __webpack_public_path__ + "img/instagram-logo.d65e31f.png";